'use strict';

class BloomreachService {
  // Pushes payload to Bloomreach.
  push(payload) {
    if (!payload) {
      return;
    }

    if (BrTrk) {
      BrTrk.getTracker().updateBrData(payload);
    }
  }

  logPageView() {
    if (BrTrk) {
      BrTrk.getTracker().logPageView();
    }
  }
};

let brService = new BloomreachService();
export default brService;


// WEBPACK FOOTER //
// ./assets/components/Bloomreach/BloomreachService.js